module.exports = "/assets/data/c520bfe64e92edf61e0f8e3f3f8fc318-BS10.data.json";